import React, { useEffect, useContext, useState, useCallback } from "react";
import "./Inviter.scss";
import UserContext from "../../../services/context/userContext";
import Input from "../../_default/Input";
import Button from "../../_default/Button";
import { addClient } from "../../../services/firebase/firestore/saveData";

export default function Inviter({ }) {
  const user = useContext(UserContext);
  const [mail, setMail] = useState();
  localStorage.removeItem("tabIndex")
  const [succeed, setSucceed] = useState('');

  const inviteUser = () => {
    console.log(user);
    addClient(mail, user.id, user.image, user.first_name + ' ' + user.last_name, callback =>{
      console.log(callback);
      setMail('');
      setSucceed('User has been invited');
    })
  }

  return (
    <div className="container">
      <h2>Invite new client</h2>
      <Input type="text" placeholder="Email" label="Email" value={mail} onChange={setMail} />
      <Button onSubmit={() => inviteUser()} text={succeed ? succeed : 'Send Invite'}/>
    </div>
    
  );
}
